import { createFileRoute } from "@tanstack/react-router";
import { BookingPageEditor } from "@/features/bookings/BookingPageEditor";

export const Route = createFileRoute("/_app/bookings/pages/$page")({ component: Page });

function Page() {
  const { page } = Route.useParams();
  return <BookingPageEditor id={page} />;
}
